import React, { Component } from 'react';
import Popover from '@material-ui/core/Popover';

type Props = {
  record: any,
  source: string
};

type StateProps = {
  anchorEl: any,
  open: boolean
};

class PopoverFilters extends Component<Props, StateProps> {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      open: false
    };
  }

  handleClick = (event) => {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const filterSummary = this.props.record && this.props.record.filter_summary && this.props.record.filter_summary.map((value, index) => (
      <div key={index}>{value}<br /><br /></div>
    ));

    const titleFilterSummary = this.props.record && this.props.record.filter_summary && this.props.record.filter_summary.join("\n\n");

    return (
      <span>
        <span onClick={this.handleClick} title={titleFilterSummary}>
          {this.props.record && this.props.record.filter_summary && this.props.record.filter_summary.map((value, index) => {
            if (index === 2) {
              return <span key={index}>...</span>;
            } else if (index > 2) {
              return null;
            } else {
              const maxLength = 50;
              const elipsis = value.length > maxLength ? '...' : '';
              const text = value.substr(0, maxLength) + elipsis;

              return <span style={{ whiteSpace: 'nowrap' }} key={index}>{text}<br /></span>
            }
          })}
        </span>
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          onClose={this.handleRequestClose}
        >
          <div style={{ border: '1px solid gray', padding: 10, cursor: 'pointer' }}>
            {filterSummary}
          </div>
        </Popover>
      </span>
    );
  }
};

export default PopoverFilters;



// WEBPACK FOOTER //
// ./src/views/Common/Popovers/Filters.tsx